import Vue from 'vue'

/** babel-polyfill处理器 */
import 'babel-polyfill'

/** 初始化浏览器样式 */
import 'normalize.css/normalize.css'

/** Element UI */
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

/** iconfont集成 */
import './iconfont/iconfont.css'
import './iconfont/iconfont.js'

import './styles/index.scss'

import App from './App.vue'
import router from '@/router'
import store from '@/store'

/** 国际化 */
import i18n from './lang'

import formTablePage from '@/components/formTablePage'
import tablePage from '@/components/tablePage'
import uploadPage from '@/components/uploadPage'
import paginationPage from '@/components/paginationPage'
import cusBtn from '@/components/button' // 自定义按钮
import buttonsWrap from '@/components/buttonsWrap' // 按钮栏
import stageRatio from '@/components/stageRatio' // 项目占比
import stageView from '@/components/stageView'
import rowInlineConfirm from '@/components/TableCom/rowInlineConfirm'
import permissionOperate from '@/utils/permissionOperate' // 权限操作
import downloadCustom from '@/utils/downloadCustom' // 下载
import constantCustom from '@/utils/constantCustom' // 自定义
import { formatterDecimal, dateFormatToyyyyMMdd, dateTimeFormatToyyyyMMddHHmmss } from '@/utils/formatterCustom' // 格式化

Vue.config.productionTip = false

Vue.use(ElementUI, { size: 'medium', zIndex: 2000, i18n: (key, value) => i18n.t(key, value) })

/* 定义全局方法 */
Vue.prototype.buttonPerCheck = permissionOperate.buttonPerCheck // 检查当前路由的按钮权限
Vue.prototype.getRouteParentByName = permissionOperate.getRouteParentByName // 根据父路由名称寻找父路由
Vue.prototype.updateUserRoleId = permissionOperate.updateUserRoleId // 更新当前缓存的用户信息中的默认角色id
Vue.prototype.clearPermissionList = permissionOperate.clearPermissionList // 清空权限列表

Vue.prototype.downloadByStream = downloadCustom.downloadByStream // 根据文件流下载文件

Vue.prototype.constantCustom = constantCustom // 自定义常量
Vue.prototype.getEnumsDictionariesList = constantCustom.getEnumsDictionariesList // 根据类型获取数据子典枚举
Vue.prototype.getEnumsSelectAreaNoList = constantCustom.getEnumsSelectAreaNoList // 获取地区/国家枚举
Vue.prototype.getEnumsSelectAreaPatentList = constantCustom.getEnumsSelectAreaPatentList // 根据专利公布号同步专利信息

Vue.prototype.formatterDecimal = formatterDecimal // 格式化为带位数小数，默认2位
Vue.prototype.dateFormatToyyyyMMdd = dateFormatToyyyyMMdd // 日期转换为格式yyyy MM dd
Vue.prototype.dateTimeFormatToyyyyMMddHHmmss = dateTimeFormatToyyyyMMddHHmmss // 日期转换为格式yyyy MM dd

/** 全局组件 */
Vue.component('form-table-page', formTablePage)

Vue.component('table-page', tablePage)
Vue.component('upload-page', uploadPage)
Vue.component('pagination-page', paginationPage)

Vue.component('cus-btn', cusBtn)

Vue.component('buttonsWrap', buttonsWrap)

Vue.component('stage-ratio', stageRatio)
Vue.component('stage-view',stageView)


// 行按钮操作pop
Vue.component('row-inline-confirm', rowInlineConfirm)

/** 全局组件：svgicon */
import svgicon from '@/components/SvgIcon'
Vue.component('svgicon', svgicon)

/** 全局组件：chart */
import chart from '@/components/chart'
Vue.component('chart', chart)

/** 全局组件：语言切换 */
import LangSwitcher from '@/components/LangSwitcher'
Vue.component('lang-switcher', LangSwitcher)

/** 全局组件：圆角边框 */
import card from '@/components/card'
Vue.component('card', card)
import cardHeader from '@/components/card/header'
Vue.component('card-header', cardHeader)

/** 全局组件：流程 */
import flow from '@/components/flow'
Vue.component('flow', flow)

/** 全局组件：checklist */
import checklist from '@/components/checklist'
Vue.component('checklist', checklist)

import headimg from '@/components/headimg'
Vue.component('headimg', headimg)
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
